import React from "react";

import { useDossier } from "@app/contexts/DossierContext";
import { Zap } from "lucide-react";
import { formatNumberDisplay } from "../../../utils/util";

/**
 * Display annual electric consumption
 * @returns 
 */
export default function ElectricAnnualConsumption() {
    const dossier = useDossier();    
    const structureDatas = dossier.structure_datas ?? [];    

    const totalConsumption = calculateTotalConsumption(structureDatas);

    function displaySD(structureData, index) {
        const structureDataConsumption = calculateStructureDataConsumption(structureData);

        return (
            <div key={index}>
                {structureData.structure.trade_name}: {formatNumberDisplay(structureDataConsumption)} kWh
            </div>
        )
    }

    return (
        <div className="custom-row">
            <div className="row">
                <div className="col-6">
                    <b><Zap /> Consommation totale ({structureDatas.length} compteur(s))</b>
                </div>
                <div className="col-6 text-end">
                    <div className="xl-text">{formatNumberDisplay(totalConsumption)} kWh</div>
                </div>
            </div>
            
            {structureDatas.map(displaySD)}
        </div>
    )    
}

/** Calculate total of structure datas consumptions */
function calculateTotalConsumption(structureDatas=[]) {
    let total = 0;

    structureDatas.forEach((sd) => {
        total += calculateStructureDataConsumption(sd)        
    })

    return total;
}

/** Calculate structure consumption */
function calculateStructureDataConsumption(structureData) {
    let total = 0;
    
    // Electric Index must be present and an array based on
    // {month, kWh} 
    if (structureData.electric_index && Array.isArray(structureData.electric_index)) {
        structureData.electric_index.forEach((elec) => {
            total += elec.kWh;
        })
    }

    return parseInt(total, 10);
}